import { Component, Input, inject } from "@angular/core";

import { IndividualPlan } from "../../../shared/types";
import { LanguagePipe } from "app/shared/pipes";

@Component({
	selector: "individual-plan",
	template: "{{ text | language }}",
	styleUrls: ["individual-plan.component.scss"],
	standalone: false,
})
export class IndividualPlanComponent {
	private readonly languagePipe = inject(LanguagePipe);

	text = "";

	@Input() set plan(plan: IndividualPlan) {
		if (!plan) {
			return;
		}

		const options = plan.options || [];

		// Translate individual plan options
		this.text = options.map((option) => this.languagePipe.transform(option.name)).join(", ");

		// Add description when a description has been added to the task
		if (typeof plan.notes === "string" && plan.notes.trim().length !== 0) {
			// Already items added to text? -> Change formatting
			if (options.length > 0) {
				this.text = `${this.text}, ${plan.notes}`;
			} else {
				// If no items are added, the text is the description
				this.text = `${plan.notes}`;
			}
		}
	}
}
